import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { msSurveyUrlServer } from 'src/app/global_constants';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  token:any;
  baseUrl = msSurveyUrlServer.concat("/survey/v1/survey");
  surveyClientSubject:Subject<any>;
  sendResponseSubject:Subject<any>;
  surveyListSubject:Subject<any>;
  surveyStatusSubject:Subject<any>;
  customerResponsesSubject:Subject<any>;
  standardSurveyUuidSubject:Subject<any>;
  initSurveyVisitSubject:Subject<any>;
  surveyQstSubject:Subject<any>;
  
  constructor(private httpClient:HttpClient) { 
    this.surveyClientSubject = new Subject();
    this.sendResponseSubject = new Subject();
    this.surveyListSubject = new Subject();
    this.surveyStatusSubject = new Subject();
    this.customerResponsesSubject = new Subject();
    this.standardSurveyUuidSubject = new Subject();
    this.initSurveyVisitSubject = new Subject();
    this.surveyQstSubject = new Subject();

    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");

  }

  getSurveyForClient(surveyVisitUuid : any){
    this.surveyClientSubject = new Subject();
    this.httpClient.get(this.baseUrl+'/'+surveyVisitUuid).subscribe((response: any) => {
      this.surveyClientSubject.next(response);
      this.surveyClientSubject.complete();
    },error => {
      console.log(error);
    });
  }

  getSurveyQst(surveyUuid : any){
    this.surveyQstSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'/'+surveyUuid, {headers: header}).subscribe((response: any) => {
      this.surveyQstSubject.next(response);
      this.surveyQstSubject.complete();
    },error => {
      console.log(error);
    });
  }

  getSurveyStatus(visitUuid : any){
    this.surveyStatusSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'/status/'+visitUuid, {headers: header}).subscribe((response: any) => {
      this.surveyStatusSubject.next(response);
      this.surveyStatusSubject.complete();
    },error => {
      console.log(error);
    });
  }

  getSurveyList(){
    this.surveyListSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl, {headers: header}).subscribe((response: any) => {
      this.surveyListSubject.next(response);
      this.surveyListSubject.complete();
    },error => {
      console.log(error);
    });
  }

  getCustomerResponses(visitUuid :any){
    this.customerResponsesSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'/respond/'+visitUuid, {headers: header}).subscribe((response: any) => {
      this.customerResponsesSubject.next(response);
      this.customerResponsesSubject.complete();
    },error => {
      console.log(error);
    });
  }
  
  sendResponse(reqBody : any) {
    this.sendResponseSubject = new Subject();
    this.httpClient.post(this.baseUrl+'/respond', reqBody).subscribe((response: any) => {
        this.sendResponseSubject.next(response);
        this.sendResponseSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getStandardSurveyUuid(){
    this.standardSurveyUuidSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl, {headers: header}).subscribe((response: any) => {
      this.standardSurveyUuidSubject.next(response);
      this.standardSurveyUuidSubject.complete();
    },error => {
      console.log(error);
    });
  }

  initSurveyVisit(reqBody : any) {
    this.initSurveyVisitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.post(this.baseUrl+'/visit', reqBody, {headers: header}).subscribe((response: any) => {
        this.initSurveyVisitSubject.next(response);
        this.initSurveyVisitSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getSupportSurvey(): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders().set('Authorization', "Bearer " + this.token);
    return this.httpClient.get(`${this.baseUrl}/listSupport`, { headers });
  }
}
